var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-search-container"},[_c('b-form-input',{ref:"input",staticClass:"input-search",attrs:{"placeholder":_vm.placeholder,"value":_vm.value},on:{"input":_vm.updateValue}}),_c('button',{staticClass:"btn-search",on:{"click":_vm.clearInputValue}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'times']}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }